import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=cf8b2aee&scoped=true&"
import script from "./NewCustomer.vue?vue&type=script&lang=js&"
export * from "./NewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomer.vue?vue&type=style&index=0&id=cf8b2aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8b2aee",
  null
  
)

export default component.exports